import * as PIXI from 'pixi.js';
import {toExcelFormat} from '../../../../helpers/format-position';
import {GroundPosition} from '../../../../shared/map-view/map-view.component';

enum GroundType {
  STOCK = 'STOCK',
  DOCK = 'DOCK',
  STREET = 'STREET',
  QUALITY_CONTROL = 'QUALITY_CONTROL',
  DIVERGENT_STOCK = 'DIVERGENT_STOCK',
  EXPEDITION = 'EXPEDITION',
  DAMAGES = 'DAMAGES',
  PICKING = 'PICKING',
  PROVISION = 'PROVISION',
  IN = 'IN',
  EXIT = 'EXIT',
  PIGEONHOLE = 'PIGEONHOLE',
  PICKING_MISCELLANEOUS = 'PICKING_MISCELLANEOUS',
}

const width = 50;
const height = 50;
const border = 10;
const titleStyleWhite = new PIXI.TextStyle({
  fontFamily: 'Roboto',
  fontSize: 12,
  fontWeight: 'bold',
  wordWrap: true,
  wordWrapWidth: 440,
  lineJoin: 'round',
});

const columnStyle = new PIXI.TextStyle({
  fontFamily: 'Roboto',
  fontSize: 14,
  fontWeight: 'bold',
  // fill: ['#454F63'], // gradient
  wordWrap: true,
  wordWrapWidth: 440,
  lineJoin: 'round',
});

const rowsStyle = new PIXI.TextStyle({
  fontFamily: 'Roboto',
  fontSize: 14,
  fontWeight: 'bold',
  fill: ['#454F63'], // gradient
  wordWrap: true,
  wordWrapWidth: 440,
  lineJoin: 'round',
});

export function getWidth(w) {
  return (w * width) + 50;
}
export function getHeight(h) {
  return (h * height) + 45;
}

export function drawGroundPositionUnavailable(ground: GroundPosition) {
  const graphics = new PIXI.Graphics();
  graphics.cacheAsBitmap = true;

  const initialBorder = border;
  const color = 0xeeeeee;
  graphics.beginFill(0xFFFFFF)
    .lineStyle(2, color, 1)
    .drawRoundedRect(initialBorder + ground.x * width + 50, initialBorder + ground.y * height + 45, width - 8, height - 8, 5)
    .endFill();

  graphics.hitArea = new PIXI.RoundedRectangle(ground.x * width + 50, initialBorder + ground.y * height  + 45, width -  8, height - 8, 5);
  const titleStyle = Object.assign({}, titleStyleWhite);
  titleStyle.fill = ['#eeeeee'];
  const title = new PIXI.Text(toExcelFormat(ground.x, ground.y), titleStyle);

  if (toExcelFormat(ground.x, ground.y).length === 2) {
    title.x = initialBorder +  ground.x * width + 63;
  } else if (toExcelFormat(ground.x, ground.y).length === 3) {
    title.x = initialBorder + ground.x * width + 60;
  } else {
    title.x = initialBorder + ground.x * width + 55;
  }
  title.y = initialBorder + ground.y * height + 58;
  title.resolution = 2;

  return [graphics, title];

}

export function drawGroundPositionAtGroup(ground: GroundPosition) {
  const graphics = new PIXI.Graphics();
  graphics.cacheAsBitmap = true;
  const initialBorder = border;
  const color = setFilledColor(ground.type);
  graphics.beginFill(color)
    .lineStyle(2, color === 0xFFFFFF ? 0x000000 : color, 1)
    .drawRoundedRect(initialBorder + ground.x * width + 50, initialBorder + ground.y * height + 45, width - 8, height - 8, 5)
    .endFill();

  graphics.hitArea = new PIXI.RoundedRectangle(ground.x * width + 50, initialBorder + ground.y * height  + 45, width -  8, height - 8, 5);
  const titleStyle = Object.assign({}, titleStyleWhite);
  titleStyle.fill = ['#FFFFFF'];

  const title = new PIXI.Text(toExcelFormat(ground.x, ground.y), titleStyle);

  if (toExcelFormat(ground.x, ground.y).length === 2) {
    title.x = initialBorder +  ground.x * width + 63;
  } else if (toExcelFormat(ground.x, ground.y).length === 3) {
    title.x = initialBorder + ground.x * width + 60;
  } else {
    title.x = initialBorder + ground.x * width + 55;
  }
  title.y = initialBorder + ground.y * height + 58;
  title.resolution = 2;

  return [graphics, title];
}

export function drawGroundPosition(ground: GroundPosition) {
  const graphics = new PIXI.Graphics();
  graphics.cacheAsBitmap = true;

  let color;
  const initialBorder = border;
    color = setColor(ground.type);
    graphics.beginFill(0xFFFFFF)
      .lineStyle(2, color === 0xFFFFFF ? 0x000000 : color, 1)
      .drawRoundedRect(initialBorder + ground.x * width + 50, initialBorder + ground.y * height + 45, width - 8, height - 8, 5)
      .endFill();

  graphics.hitArea = new PIXI.RoundedRectangle(ground.x * width + 50, initialBorder + ground.y * height  + 45, width -  8, height - 8, 5);
  const titleStyle = Object.assign({}, titleStyleWhite);
  titleStyle.fill = [color];

  const title = new PIXI.Text(toExcelFormat(ground.x, ground.y), titleStyle);

  if (toExcelFormat(ground.x, ground.y).length === 2) {
    title.x = initialBorder +  ground.x * width + 63;
  } else if (toExcelFormat(ground.x, ground.y).length === 3) {
    title.x = initialBorder + ground.x * width + 60;
  } else {
    title.x = initialBorder + ground.x * width + 55;
  }
  title.y = initialBorder + ground.y * height + 58;
  title.resolution = 2;

  return [graphics, title];
}

function setFilledColor(groundType) {
  switch (groundType) {
    case GroundType.STREET:
      return 0x89909F;
    case GroundType.STOCK:
      return 0x92B531;
    case GroundType.DOCK:
      return 0x3D539E;
    case GroundType.EXPEDITION:
      return 0x0F8A8D;
    case GroundType.QUALITY_CONTROL:
      return 0x4E146C;
    case GroundType.DIVERGENT_STOCK:
      return 0xB02A09;
    case GroundType.DAMAGES:
      return 0x9B7D08;
    case GroundType.PICKING:
      return 0xE10767;
    case GroundType.PROVISION:
      return 0x29A66C;
    case GroundType.IN:
      return 0xEC8E00;
    case GroundType.EXIT:
      return 0x000000;
    case GroundType.PIGEONHOLE:
      return 0x87CEEB;
    case GroundType.PICKING_MISCELLANEOUS:
      return 0xC54B8C;
    default:
      return 0xFFFFFF; // default color
  }
}

function setColor(groundType) {
  switch (groundType) {
    case GroundType.STREET:
      return 0x9BA1AF;
    case GroundType.STOCK:
      return 0xA1B76D;
    case GroundType.DOCK:
      return 0x6E7CAF;
    case GroundType.EXPEDITION:
      return 0x65A3AB;
    case GroundType.QUALITY_CONTROL:
      return 0x826799;
    case GroundType.DIVERGENT_STOCK:
      return 0xB26455;
    case GroundType.DAMAGES:
      return 0xA69654;
    case GroundType.PICKING:
      return 0xCC6096;
    case GroundType.PROVISION:
      return 0x61AE90;
    case GroundType.IN:
      return 0xD6A050;
    case GroundType.EXIT:
      return 0x000000;
    case GroundType.PIGEONHOLE:
      return 0x87CEEB;
    case GroundType.PICKING_MISCELLANEOUS:
      return 0xC54B8C;
    default:
      return 0xFFFFFF; // default color
  }
}

export function drawColumns(positionsX) {
  const columns = [];
  const initialBorder = border;
  for (const x of positionsX) {
    const grade = setColumns(x);

    const columnsText = new PIXI.Text(grade, columnStyle);
    columnsText.resolution = 1.5;
    columnsText.y = initialBorder;
    columnsText.position.x = grade.length === 3 ? initialBorder + x * width + 55 : grade.length === 2 ? initialBorder + x * width + 60 : initialBorder + x * width + 65;
    columnsText.style.wordWrap = false;
    columns.push(columnsText);
  }

  return columns;
}

function setColumns(x) {
  let column = '';
  while (x >= 0) {
    const mod = x % 26;
    const modX = 65 + mod;
    column = String.fromCharCode(modX) + column;
    x = (x - mod - 1) / 26;
  }
  return column;
}

export function drawRows(positionsY) {
  const rows = [];

  for (const y of positionsY) {
    const grade = setRows(y);
    const initialBorder = border;

    const rowsText = new PIXI.Text(grade, rowsStyle);
    rowsText.resolution = 1.5;
    rowsText.position.x = initialBorder + 5;
    rowsText.position.y = initialBorder + (y * (height) + 50)+6;
    rowsText.style.wordWrap = true;
    rowsText.style.wordWrapWidth = 10;
    rows.push(rowsText);
  }
  return rows;
}

function setRows(y) {
  return (y + 1).toString();
}
